<template>

  <split-pane :defaultPercent="20">

    <div class="mw-split-left" slot="paneL">
      <el-dialog title="新建文件夹" width="30%" :visible.sync="dialogTableVisible" small @close="addFolderParentFolder=''">
        <div style="margin-top:5px;">
          <el-input v-model="fileName" placeholder="请输入文件名">
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelNewFile">取 消</el-button>
          <el-button type="primary" @click="saveFolder">确 定</el-button>
        </span>
      </el-dialog>
      <div class="mw-toolbar">
        <mw-button @click="addFolder" icon="fa fa-plus">新建文件夹</mw-button>
        <mw-button @click="deleteFolder" icon="fa fa-remove">删除</mw-button>
      </div>
      <el-tree :data="treeData" node-key="id" :default-checked-keys="defaultCheckedKeys" show-checkbox
               lazy :load="loadTreeNode" @node-click="handleNodeClick" @node-contextmenu="nodeContextMenu"
               ref="folderTree" highlight-current :expand-on-click-node="false" check-strictly></el-tree>
    </div>
    <div class="mw-split-right" slot="paneR">
      <div class="mw-panel">
        <mw-dialog ref = "img_show" title="文件浏览" :before-close="handle_img_showClose" :close-on-click-modal="false" size="small_large">
          <div style="margin-top:5px;height:98%;">
              <img width='100%' height='100%' :src="imgUrl"/>
          </div>
        </mw-dialog>
        <!-- <mw-dialog ref="upload" title="上传附件" size="small_small"
                   :before-close="handleClose" :close-on-click-modal="false">
          <el-upload ref="sysDicUpload" :on-success="importSuccessCallback"
                     style="display: inline-block"
                     :auto-upload="true"
                     :data="fdata"
                     :action="action"
                     :headers="headers"
                     :show-file-list="showFileList"
                     :before-upload="beforeAvatarUpload"
          >
            <el-button id="uploadBtn">上传文件</el-button>
          </el-upload>
        </mw-dialog> -->
        <toolbar-table ref="viewToolbarTable" :layout="layout" :autoLoad="autoLoad">
          <span>
            <el-button  type="info" @click="showHelp" size="mini"  ><i class="fa fa-question"></i>帮助2</el-button>
          </span>
        </toolbar-table>
      </div>
    </div>
  </split-pane>

</template>

<script>
  export default {
    props:{
      params:Object
    },
    name: "file_manager",
    data() {
      let appId = _.get(this,"params.appId",_.get(this,"$route.params.appId"));
      let sysId = _.get(this,"$route.params.sysId");
      return {
        autoLoad:false,
        selFolderName:"",
        defaultCheckedKeys: [""],
        dialogTableVisible: false,
        treeData: [],
        fileList: [],
        fileName: "",
        showFileList: false,
        headers: {},
        fdata: {},
        action: this.mwUrl('/api/file/upload'),
        pagination: false,
        noPaginationLimit: 20,
        layout: [],
        appId,
        sysId,
        imgUrl:"",
        imgTypes:["png","jpg","bmp","tif","gif","PNG","JPG","BMP","TIF","GIF"],
        coreEditorTypes:["js","css","JS","CSS"],
        form: {},
        refreshingFileName: '',
        addFolderParentFolder:""
      }
    },
    created: function () {
      var me = this;
      this.$nextTick(function () {
        if (me.treeData.length > 0) {
          me.$refs.folderTree.setCurrentKey(me.treeData[0].label);
          me.selFolderName=me.treeData[0].label;
          me.loadData()
        }
      })
    },
    mounted: function () {
      var me = this;
      me.fdata = {
        appId: me.appId
      };
      //me.listFolder();
      me.layout =
        [
          [{
            key: 'file',
            type: 'menu',
            defaultActive: true,
            pagination: false,
            label: '文件管理',
            api: 'filemanager.listFiles',
            defaultParams: {appId: me.appId, folder:me.selFolderName, category: 'file'},
            defaultSort: [{sort: 'createTime', dir: 'desc'}],
            columns: [
              {type: 'selection'},
              {prop: 'name', tooltip: true, label: '名称', formatter: me.nameFormatter},
              {prop: 'type', label: '类型', width: '150'},
              {prop: 'size', label: '大小', width: '100',formatter: me.sizeFormatter}
            ]
          }, {
              span: 20, type: 'button', items: [
                {label: '上传', icon: "fa fa-upload", func: me.uploadFile},
                {label: '下载', icon: "fa fa-download", func: me.downloadFile},
                {label: '替换', icon: "fa fa-refresh", func: me.refreshFile},
                {label: '删除', icon: "fa fa-trash-o fa-fw", func: me.delFile},
                {label: '获取路径', icon: "fa fa-map", func: me.getUrl}
              ]
          },{
            span: 4, type: 'custom', items: []
          }]
        ]
        me.$nextTick(function(){
          $(me.$el).find("[toolbar_custom_area='true']").append('<button id="showhelp" style="float:right;" type="button" class="el-button el-button--info"><span><i class="fa fa-question"></i><span>帮助</span></span></button>');
          $("#showhelp").click(function(){
            me.showHelp();
          })
        })
    },
    methods: {
      contextMenu(event, object, value, element) {
        this.menuVisible = true;
      },
      handleNodeClick(data) {
        let me=this;
        let name = data.label;
        if (!name) return;
        me.selFolderName=name;
        me.loadData();

      },
      loadTreeNode(node,resolve){
        let me=this;
        let appId=node.level===0?this.appId:this.appId+"/"+node.data.id;
        MW.mwApi.filemanager.listFolder({appId}).then(res=>{
          let r=res?res.result:null;
          if (r && r.length > 0) {
            let pid=node.level===0?"":node.data.id;
            let nodes=r.map(function (el) {
              return {label: el.name,id:(pid?pid+"/":"")+el.name};
            })
            resolve(nodes);
            setTimeout(()=> {
              me.$refs.folderTree.setCurrentKey(nodes[0].id);
              me.loadData();
            },100)
          } else {
            resolve([]);
          }
          me.$parent.$emit('updateTreeCount', {
            id: 'file_manager',
            length: r.length || 0
          });
        });
      },
      nodeContextMenu(event,data,node) {
        let me=this;
        let contextMenu=PF.contextMenu({
          autoDestroy:true,
          items:[{
            text:"新建子文件夹",
            icon:"fa fa-new",
            handler:function(){
              me.addFolderParentFolder=data.id;
              me.addFolder();
            }
          }]
        });
        contextMenu.show(event.pageX,event.pageY);
      },
      loadData(){
        var me=this;
        var selFolderName=me.$refs.folderTree.getCurrentKey();
        if(!selFolderName) return false;
        MW.mwApi.filemanager.listFiles({appId:me.appId,folder:selFolderName}).then((r)=>{
          if(r&&r.result.length>0){
            me.$refs.viewToolbarTable.refreshTableDataList(r.result);
          }else{
            me.$refs.viewToolbarTable.refreshTableDataList([]);
          }
        })
      },
      listFolder(selLabel) {
        /*let me = this;
        MW.mwApi.filemanager.listFolder({appId:me.appId}).then(function(res){
          let r=res?res.result:null;
          if (r && r.length > 0) {
            me.treeData = $.map(r, function (el) {
              return {label: el.name};
            });
            me.$nextTick(function(){
              selLabel=selLabel||me.treeData[0].label;
              this.$refs.folderTree.setCurrentKey(selLabel);
              me.loadData();
            })
          } else {
            me.treeData = [];
            me.loadData();
          }
          me.$parent.$emit('updateTreeCount', {
            id: 'file_manager',
            length: r.length || 0
          });
        });*/
      },
      cancelNewFile() {
        this.dialogTableVisible = false;
        this.fileName = "";
      },
      saveFolder() {
        var me = this;
        if (!this.fileName) {
          this.$alert("请输入文件名");
          return;
        }
        var fileName = this.fileName;
        if (/^[^\\/:*?""<>|,\\.]+$/.test(fileName) == false) {
          this.$alert("文件名不能包含特殊字符");

          return;
        }
        let tree=me.$refs.folderTree;
        let parentNode;
        if(me.addFolderParentFolder){
          fileName=me.addFolderParentFolder + "/" +fileName;
          parentNode=tree.getNode(me.addFolderParentFolder)
        }else{
          parentNode=tree.root;
        }
        me.fileName = "";

        me.addFolderParentFolder="";
        me.dialogTableVisible = false;
        MW.mwApi.filemanager.addFolder({ appId: me.appId, folder:fileName}).then(function(res){
          let r = res ? res.result : null;
          if (r) {
            if (r.success === true) {
              //me.listFolder(fileName);
              tree.append({label:fileName.split("/").pop(),id:fileName},parentNode);
              parentNode.expand();
              setTimeout(()=>tree.setCurrentKey(fileName),200);
            } else {
              alert(r.msg);
            }
          }
        })
      },
      listFiles(params){
        var me=this;
        params=params||{};

      },
      addFolder() {
        this.dialogTableVisible = true;
      },
      deleteFolder() {
        var me = this;
        var folderName = "";
        var nodes = me.$refs.folderTree.getCheckedNodes();
        if (!nodes || nodes == 0) {
          me.$alert("请选择要删除的文件夹");
          return;
        }

        folderName = $.map(nodes, function (el) {
          return el.id;
        }).join("|");
        MW.mwApi.filemanager.deleteFolder({ appId: me.appId, folder:folderName}).then(function(res){
          let r=res?res.result:null;
          if (r) {
            if (r.success == true) {
              nodes.forEach(n=>me.$refs.folderTree.remove(n))
            } else {
              alert(r.msg);
            }
          }
        });

      },
      importSuccessCallback(resp, file, fileList) {
        if (this.refreshingFileName) {
          this.$alert("替换成功");
        }
        this.loadData();
        this.handleClose();
      },
      nameFormatter(data) {
        let me=this;
        if(me.imgTypes.indexOf(data.type) != -1 || me.coreEditorTypes.indexOf(data.type) != -1){
          return (<span slot="reference" class={{'link':true}} title={data.name} onClick={(event)=>me._showForm(data,event)}>
              {data.name?data.name:'无标题'}
            </span>)
        }else{
          return data.name;
        }
      },
      sizeFormatter(data){
        let size=data.size;
        if(size<0){
          return "0KB";
        }
        size=size/1024;
        if(size<1024){
          return size.toFixed(2)+"KB";
        }
        size/=1024;
        return size.toFixed(2)+"MB";
      },
      _showForm(row, event) {
        event.stopPropagation();
        let me = this;
        let url = "/FILE_MANAGER/"+this.appId+"/"+me.$refs.folderTree.getCurrentKey()+"/"+row.name;
        if(me.imgTypes.indexOf(row.type) != -1){
            me.imgUrl = url;
            me.mwRef("img_show").show();
        }else if(me.coreEditorTypes.indexOf(row.type) != -1){
            $.get(url,function(res){
                let lang = ["css","CSS"].indexOf(row.type) != -1 ? "CSS":"";
                PF.dialog("MwCodeEdit",{
                  title:row.name,
                  propsData:{value:res,lang:lang}
                });
            },"text")
        }
      },
      getUrl(){
        var me = this;
        let sels=me.$refs.viewToolbarTable.getMultipleSelection();
        if(!sels||sels.length!=1){
          me.$alert("请选择一个要查看路径的文件");
          return;
        }
        var url = "/FILE_MANAGER/"+this.appId+"/"+me.$refs.folderTree.getCurrentKey()+"/"+sels[0].name;
        this.$alert("<span style='word-break:break-all;'>"+url+"</span>",'文件路径', {
          dangerouslyUseHTMLString: true,
          callback: action => {
          }
        });

      },
      handle_img_showClose:function(){
        this.mwRef("img_show").hide();
      },
      handleClose: function () {
        this.refreshingFileName = '';
      },
      uploadFile() {
        let me=this;
        me.fdata.folder=me.$refs.folderTree.getCurrentKey();
        if(!me.fdata.folder){
          alert("请选择文件夹");
          return;
        }

        var comp=PF.createVue({
            template:`<el-upload ref='uploader' :show-file-list='false' :on-success="importSuccessCallback"
                     style="display: inline-block"
                     :auto-upload="true"
                     :data="fdata"
                     :action="action"
                     :before-upload="beforeAvatarUpload"></el-upload>`,
            data() {
              return{
                action: me.action,
                fdata: me.fdata
              }
            },
            mounted:function(){
              this.$refs.uploader.$refs["upload-inner"].$refs.input.click();
            },
            methods: {
              importSuccessCallback(resp, file, fileList){
                me.importSuccessCallback(resp, file, fileList);
              },
              beforeAvatarUpload(file, fileList){
                me.beforeAvatarUpload(file, fileList);
              }
            }
        });
        comp.$mount();


        // this.mwRef("upload").show(function(){
        //   console.log("$('#uploadBtn').length: ", $('#uploadBtn').length);
        //   $('#uploadBtn').click();
        // });
      },
      async downloadFile() {
        let me = this;
        let folderName=me.$refs.folderTree.getCurrentKey();
        if(!folderName){
          return;
        }

        let sels = me.$refs.viewToolbarTable.getMultipleSelection();
        let params = {
          appId: me.appId,
          folder: encodeURIComponent(folderName)
        };

        if(sels.length > 0) {
          sels.forEach(item => {
            params.name = encodeURIComponent(item.name);
            MW.mwApi.filemanager.downloadFile2(params).then((res)=>{
              if (!res.success && res.msg) {
                me.$alert(res.msg);
              }
            });
          });
        } else {
          me.$alert("请选择要下载的文件");
          return;
        }
      },
      refreshFile() {
        let me = this;
        let folderName=me.$refs.folderTree.getCurrentKey();
        if(!folderName){
          return;
        }

        let sels = me.$refs.viewToolbarTable.getMultipleSelection();

        if (sels.length == 1) {
          me.mwConfirm('此操作将会以上传的文件替换掉原文件，确定要继续吗?').then(() => {
            me.refreshingFileName =  sels[0].name;
            let params={
              appId: me.appId,
              folder: folderName,
              name: me.refreshingFileName
            }
            me.uploadFile();
          });
          // MW.mwApi.filemanager.downloadFile2(params);
        } else {
          me.$alert("请选择一个要替换的文件");
          return;
        }
      },
      delFile: function (records) {
        let me=this;
        let folderName=me.$refs.folderTree.getCurrentKey();
        if(!folderName){
          return;
        }
        let sels=me.$refs.viewToolbarTable.getMultipleSelection();

        if(!sels||sels.length==0){
          me.$alert("请选择要删除的文件");
          return;
        }

        me.mwConfirm('您确定要删除选中的文件吗?').then(() => {

          let name=$.map(sels,function(el){
            return el.name||"";
          }).join("|");

          let params={
            appId:me.appId,
            folder:folderName,
            name:name
          }
          MW.mwApi.filemanager.deleteFile(params).then(function(r){
            me.loadData();
          })
        });

      },
      beforeAvatarUpload(file, fileList){
        if (this.refreshingFileName) {
          if (this.refreshingFileName !== file.name) {
            this.$alert('请使用相同名字与类型的文件替换');
            this.refreshingFileName = '';
            return false;
          } else {
            // TIPS: 会直接替换掉原来的文件, 所以不用删除原文件
            // TIPS: 如果后期需求可以用不同文件类型或者不需要同名文件替换, 再开放出来
            // const delPromise = (resolve, reject) => {
            //   try {
            //     MW.mwApi.filemanager.deleteFile({appId: this.appId, folder: this.$refs.folderTree.getCurrentKey(), name: this.refreshingFileName});
            //     resolve();
            //   } catch (error) {
            //     reject(error);
            //   }
            // }
            // return new Promise(delPromise);
          }
        }
      },
      timeFormatter: function (data, c, v) {
        if (v) {
          var time = v;
          return time.substring(5, time.length - 3)
        }
        return v
      },
      search: function () {
        this.mwRef('viewToolbarTable').searchText();
      },
      refreshTable: function () {
        this.mwRef('viewToolbarTable').refreshTable();
      },
      showHelp(){
        PF.showHelp({title:'文件管理说明',url:'/helpDoc/platform/file_manage.md'});
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/index/views/appModule/file_manager/index.vue